import { Skeleton } from "@ecco/ui/skeleton";
import { Box } from "@ecco/ui/box";
import { Grid, GridItem } from "@ecco/ui/grid";
import { BoxWithRibbon } from "../BoxWithRIbbon";
import { styles } from "./EccoClubCardsStyles";

const MembershipDetailsSkeleton = () => {
    return (
        <BoxWithRibbon>
            <Box paddingBottom={[2, 4, 6]} style={styles.membershipInfoContainer}>
                <Grid templateColumns={["1fr", "1fr 1fr"]} gap={[4, 8, 12]} mb={4}>
                    <MembershipInfoSkeleton />
                    <MembershipInfoSkeleton />
                </Grid>
            </Box>

            <Box paddingTop={[2, 4, 6]} maxWidth={["100%", "60%"]}>
                <TextSkeleton width="20%" height={5} marginBottom={1} />
                <TextSkeleton width="100%" height={5} marginBottom={1} />
                <TextSkeleton width="80%" height={20} marginBottom={2} />
                <TextSkeleton width="20%" height={5} marginBottom={1} />
                <TextSkeleton width="80%" height={5} />
            </Box>
        </BoxWithRibbon>
    );
};

const MembershipInfoSkeleton = () => (
    <GridItem>
        <Skeleton w="60%" h={5} mb={2} />
        <Skeleton w="60%" h={16} />
    </GridItem>
);

const TextSkeleton = ({
    width,
    height,
    marginBottom,
}: {
    width: string;
    height: number;
    marginBottom?: number;
}) => <Skeleton w={width} h={height} mb={marginBottom} />;

export default MembershipDetailsSkeleton;
